var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDownBlue2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89426 6.63364C10.0371 6.48368 10.0313 6.24631 9.88137 6.10347C9.7314 5.96063 9.49404 5.9664 9.35119 6.11636L6.37395 9.242V1.875C6.37395 1.66789 6.20605 1.5 5.99895 1.5C5.79184 1.5 5.62395 1.66789 5.62395 1.875V9.24218L2.64653 6.11636C2.50369 5.9664 2.26632 5.96063 2.11636 6.10347C1.9664 6.24631 1.96062 6.48368 2.10347 6.63364L5.63682 10.3431C5.71733 10.4276 5.82004 10.4776 5.92681 10.4931C5.95015 10.4976 5.97427 10.5 5.99895 10.5C6.0238 10.5 6.04808 10.4976 6.07157 10.493C6.17811 10.4774 6.28056 10.4275 6.36091 10.3431L9.89426 6.63364Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownBlue2);
export default __webpack_public_path__ + "static/media/icon-arrow-down-blue2.2bf391751916d6b653801e79735f4c11.svg";
export { ForwardRef as ReactComponent };